<div class="header">
  <div class="header-title-container">
    Id du groupe: {{selectedGroup?.id}}
  </div>
  <div class="header-btn-container">
    <button mat-icon-button title="" (click)="goToGroups()">
      <mat-icon>cancel</mat-icon>
    </button>
  </div>
</div>
<section class="grid">
  <ms-stat-card-widget [title]="'Nombre total d\'utilisateurs'" [value]="widgets.allUsers"
                       [progressPercent]="100"></ms-stat-card-widget>
  <ms-stat-card-widget [title]="'Nombre d\'utilisateurs actifs'" [value]="widgets.activeUsers"
                       [progressPercent]="(widgets.activeUsers / widgets.allUsers) * 100"></ms-stat-card-widget>
  <ms-stat-card-widget [title]="'Nombre d\'utilisateurs désactivés'" [value]="widgets.inactiveUsers"
                       [progressPercent]="(widgets.inactiveUsers / widgets.allUsers) * 100"></ms-stat-card-widget>
  @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_USER_DIARY)) {
    <ms-stat-card-widget [title]="'Nombre de patients agenda en ligne'" [value]="widgets.agendaUsers"
                         [progressPercent]="100"></ms-stat-card-widget>
  }
</section>
<div class="tab-group-container">
  <mat-tab-group>
    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_USER)) {
      <mat-tab label="Utilisateurs">
        @if (!isLoading) {
          <ms-database-group-info-user [listOfUsers]="listOfUsers" [listOfHcps]="listOfHcps"
                                       [groupInfos]="selectedGroup"
                                       [versionType]="versionType"></ms-database-group-info-user>
        }
      </mat-tab>
    }
    <mat-tab label="Logs">
      @if (!isLoading) {
        <ms-database-group-info-logs [listOfUsers]="listOfUsers" [listOfHcps]="listOfHcps"
                                     [groupId]="groupId"></ms-database-group-info-logs>
      }
    </mat-tab>
    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_HARDWARE)) {
      <mat-tab label="Infos matériel">
        @if (!isLoading) {
          <ms-database-group-info-hardware [desktopInfos]="desktopInfos"></ms-database-group-info-hardware>
        }
      </mat-tab>
    }
    <!--<mat-tab label="Infos logiciel" *ngIf="accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_SOFTWARE)">
      <ms-database-group-info-software *ngIf="!isLoading"></ms-database-group-info-software>
    </mat-tab>-->
    <mat-tab label="App settings">
      <ms-database-group-info-app-settings [appSettings]="appSettings" [selectedGroup]="selectedGroup"
                                           (appSettingsCreated)="reloadAppSettings()"
                                           *ngIf="!isLoading"></ms-database-group-info-app-settings>
    </mat-tab>
    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_DATABASE)) {
      <mat-tab label="Infos db cloud">
        @if (!isLoading) {
          <ms-database-group-info-database [groupStorageInfos]="groupStorageInfos"
                                           [selectedGroup]="selectedGroup"></ms-database-group-info-database>
        }
      </mat-tab>
    }
    @if (accessMatrixService?.isAvailableModule(RouteTypeEnum.DATABASE, ModuleTypeEnum.DATABASE_GROUP, SubModuleTypeEnum.DATABASE_GROUP_INFO_TOOLS)) {
      <mat-tab label="Outils">
        @if (!isLoading) {
          <ms-database-group-info-tools [selectedGroup]="selectedGroup"></ms-database-group-info-tools>
        }
      </mat-tab>
    }
  </mat-tab-group>
</div>
<ms-activity-indicator-with-messages [fullWidth]="true" [isLoading]="isLoading" [overlay]="true" [messages]="messages"></ms-activity-indicator-with-messages>



